import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { href: '/', label: '首页' },
  { href: '/category/ai-qing-yu-qin-mi', label: '分类探索' },
  { href: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          className="flex items-center gap-2 group"
        >
          <span className="text-xl md:text-2xl font-bold font-heading text-primary-400 group-hover:text-primary-300 transition-colors duration-300">
            欲望之岛
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                location.pathname === link.href
                  ? 'text-primary-400'
                  : 'text-foreground-400 hover:text-primary-300'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#newsletter"
            className="btn-primary !px-5 !py-2.5 text-sm !rounded-full"
          >
            开始探索
          </a>
        </div>

        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-foreground-300 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/50 animate-fade-in">
          <div className="container-custom py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium py-2 transition-colors duration-300 ${
                  location.pathname === link.href
                    ? 'text-primary-400'
                    : 'text-foreground-400'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#newsletter"
              className="btn-primary !px-5 !py-2.5 text-sm mt-2 !rounded-full inline-flex w-fit"
            >
              开始探索
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}